import React, {useMemo} from 'react';

import {IProductLongDescriptionProps} from './IProductLongDescription';

import styles from './ProductLongDescription.module.scss';

const ProductLongDescription = ({description}: IProductLongDescriptionProps) => {
	const separatedInformation = useMemo(() => {
		const descriptionItems = description.split('<br />');

		if (descriptionItems[0] === '') {
			descriptionItems.shift();
		}

		return descriptionItems;
	}, [description]);

	return description ? (separatedInformation.map((description, index) =>
		<div key={index} className={styles['product-details']}>
			<div
				className={styles['product-details__text']}
				dangerouslySetInnerHTML={{__html: description}}
			/>
		</div>
	)) : null;
};

export default ProductLongDescription;
